import EpdServiceClient, { post, get, delete_ } from "../EpdServiceClient";
import { UpsertConstruction, UpsertConstructionResponse } from "@/types/Views/CreateConstruction/NewConstruction";

// API Paths
const path = "api/construction/";
const pathV2 = "api/construction/v2/";

async function upsertConstruction(construction: UpsertConstruction): Promise<UpsertConstructionResponse> {
  return post(pathV2, construction);
}

async function getConstruction(id: string): Promise<UpsertConstruction> {
  return get(`${pathV2}${id}`);
}

async function deleteConstruction(id: string) {
  return delete_(`${path}${id}`);
}

export { upsertConstruction, getConstruction, deleteConstruction };

// The inspect endpoint (non-v2) returns the construction with its aggregated lciaResults — unlike
// getConstruction (api/construction/v2), which returns the editable upsert shape without them.
// Used to read a construction's GWP / declared unit when inspecting it inline (e.g. the EPD picker).
export async function getConstructionById(id: string) {
  const response = await EpdServiceClient.get(`${path}${id}`);
  if (response.status === 200) {
    return response.data;
  } else {
    return undefined;
  }
}

export async function getConstructionsByFilterAndSearch({
  declaredUnit,
  internalId,
  isCustom,
  isPublic,
  pageNumber,
  pageSize,
  search,
  tags,
  tenants,
  owners,
}: {
  declaredUnit: string[];
  internalId: string[];
  isCustom?: boolean;
  isPublic?: boolean;
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  tags: string[];
  tenants: string[];
  owners: string[];
}) {
  const requestBody = {
    declaredUnit,
    internalId: internalId || undefined,
    isConstruction: true,
    isCustom: isCustom || undefined,
    isPublic: isPublic || undefined,
    pageNumber: pageNumber || undefined,
    pageSize: pageSize || undefined,
    search: search || undefined,
    tags,
    tenantIds: tenants,
    owner: owners,
  };

  // Remove undefined values from the request body
  let cleanedBody = Object.fromEntries(Object.entries(requestBody).filter(([_, value]) => value !== undefined));

  // Remove empty arrays from the request body
  cleanedBody = Object.fromEntries(
    Object.entries(cleanedBody).filter(([_, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return true;
    })
  );

  const response = await EpdServiceClient.post(`${path}Search`, cleanedBody);

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}
